import { render } from "./BTCProductionAll.vue?vue&type=template&id=786b753e"
import script from "./BTCProductionAll.vue?vue&type=script&lang=js"
export * from "./BTCProductionAll.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__